package uz.ferro.erp.feature.task.model

import kotlinx.serialization.Serializable
import uz.ferro.erp.feature.task.model.dto.TaskDto

@Serializable
data class ExcelToTaskResult(
    val tasks: List<TaskDto>,
    val errors: List<String>
)